import { render, staticRenderFns } from "./TamKaskoContainer.vue?vue&type=template&id=7a08cfdc"
import script from "./TamKaskoContainer.vue?vue&type=script&lang=ts"
export * from "./TamKaskoContainer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports